// extracted by mini-css-extract-plugin
module.exports = {"host":"BaseChip_host__1ZNxT","dark":"BaseChip_dark__1-w0w"};